/* Northline: estimated delivery date for UK next day delivery (UK time, working days). */
if (!customElements.get('nl-delivery-date')) {
  class NlDeliveryDate extends HTMLElement {
    connectedCallback() {
      const cutoff = parseInt(this.dataset.cutoff || '15', 10);
      let parts;
      try {
        parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          hour12: false,
        }).formatToParts(new Date());
      } catch (e) {
        return;
      }
      const get = (t) => parseInt((parts.find((p) => p.type === t) || {}).value, 10);
      const day = new Date(Date.UTC(get('year'), get('month') - 1, get('day')));
      const hour = get('hour') % 24;
      const isWorkday = (d) => d.getUTCDay() >= 1 && d.getUTCDay() <= 5;
      const nextWorkday = (d) => {
        const n = new Date(d.getTime());
        do {
          n.setUTCDate(n.getUTCDate() + 1);
        } while (!isWorkday(n));
        return n;
      };
      const dispatch = isWorkday(day) && hour < cutoff ? day : nextWorkday(day);
      const arrive = nextWorkday(dispatch);
      const label = arrive.toLocaleDateString('en-GB', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        timeZone: 'UTC',
      });
      this.innerHTML = 'Order now and receive by <strong>' + label + '</strong>';
    }
  }
  customElements.define('nl-delivery-date', NlDeliveryDate);
}
